import React, { createContext, Dispatch, PropsWithChildren, ReactElement, SetStateAction, useState } from 'react';

export const WindowStackProvider = ({ children }: PropsWithChildren<Record<never, never>>) => {
    const [windowStack, setWindowStack] = useState<WindowStack>([]);
    return (
        <WindowStackContext.Provider value={{ windowStack, setWindowStack }}>
            {children}
            {windowStack.map(({ element }) => element)}
        </WindowStackContext.Provider>
    );
};

export const WindowStackContext = createContext<{
    windowStack: WindowStack;
    setWindowStack: SetWindowStack;
}>({
    windowStack: [],
    setWindowStack: () => {}
});

type SetWindowStack = Dispatch<SetStateAction<WindowStack>>;
export type WindowStack = {
    key: string;
    element: ReactElement;
}[];